(function () {
  'use strict';

  const STORAGE_KEY = 'stitchly:newsletter-popup';
  const SESSION_SHOWN_KEY = 'stitchly:newsletter-popup-session';

  function init() {
    const root = document.querySelector('[data-newsletter-popup]');
    if (!root) return;

    if (window.Shopify && window.Shopify.designMode) {
      open(root);
      return;
    }

    if (shouldSuppress(root)) return;
    if (sessionStorage.getItem(SESSION_SHOWN_KEY)) return;

    bindClose(root);
    bindNext(root);
    bindForm(root);
    bindCopy(root);
    armTriggers(root);
  }

  function shouldSuppress(root) {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const data = JSON.parse(raw);
      const days = parseInt(root.dataset.frequencyDays, 10) || 14;
      const ttlDays = data.subscribed ? 365 : days;
      const expiresAt = data.timestamp + ttlDays * 24 * 60 * 60 * 1000;
      return Date.now() < expiresAt;
    } catch (e) {
      return false;
    }
  }

  function remember(state) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ timestamp: Date.now(), ...state })
      );
    } catch (e) {}
  }

  function armTriggers(root) {
    const scrollPct = parseInt(root.dataset.scrollPercent, 10) || 50;
    const delaySec = parseInt(root.dataset.delaySeconds, 10) || 20;
    const exitIntent = root.dataset.exitIntent === 'true';
    let fired = false;

    const trigger = () => {
      if (fired) return;
      fired = true;
      cleanup();
      open(root);
    };

    const onScroll = () => {
      const scrolled =
        window.scrollY /
        Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (scrolled * 100 >= scrollPct) trigger();
    };

    const onMouseLeave = (e) => {
      if (e.clientY <= 0) trigger();
    };

    const timer = window.setTimeout(trigger, delaySec * 1000);

    window.addEventListener('scroll', onScroll, { passive: true });
    if (exitIntent && window.matchMedia('(min-width: 990px)').matches) {
      document.documentElement.addEventListener('mouseleave', onMouseLeave);
    }

    function cleanup() {
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.documentElement.removeEventListener('mouseleave', onMouseLeave);
    }
  }

  function open(root) {
    root.hidden = false;
    requestAnimationFrame(() => {
      root.dataset.state = 'open';
      sessionStorage.setItem(SESSION_SHOWN_KEY, '1');
      const closeBtn = root.querySelector('.newsletter-popup__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    });
    document.addEventListener('keydown', onEscape);

    function onEscape(e) {
      if (e.key === 'Escape') {
        close(root);
        document.removeEventListener('keydown', onEscape);
      }
    }
  }

  function close(root) {
    root.dataset.state = 'closed';
    window.setTimeout(() => {
      root.hidden = true;
    }, 280);
    if (!root.dataset.subscribed) remember({ subscribed: false });
  }

  function bindClose(root) {
    root.querySelectorAll('[data-newsletter-popup-close]').forEach((el) => {
      el.addEventListener('click', () => close(root));
    });
  }

  function bindNext(root) {
    const nextBtn = root.querySelector('[data-newsletter-popup-next]');
    if (!nextBtn) return;
    nextBtn.addEventListener('click', () => {
      showStep(root, 'email');
      const input = root.querySelector('input[type="email"]');
      if (input) window.setTimeout(() => input.focus(), 50);
    });
  }

  function bindForm(root) {
    const form = root.querySelector('#NewsletterPopupForm');
    if (!form) return;
    const iframe = root.querySelector('[data-newsletter-popup-iframe]');

    form.addEventListener('submit', (e) => {
      const errEl = form.querySelector('[data-newsletter-popup-error]');
      errEl.hidden = true;
      errEl.textContent = '';

      const input = form.querySelector('input[type="email"]');
      const email = (input.value || '').trim();
      if (!isValidEmail(email)) {
        e.preventDefault();
        errEl.textContent = 'Vul een geldig e-mailadres in.';
        errEl.hidden = false;
        input.focus();
        return;
      }

      const consentBox = form.querySelector('[data-newsletter-popup-consent]');
      const marketingFlag = form.querySelector('[data-newsletter-popup-marketing-flag]');
      if (marketingFlag) {
        marketingFlag.value = consentBox && consentBox.checked ? 'true' : 'false';
      }

      form.dataset.loading = 'true';

      let settled = false;
      const settle = (ok) => {
        if (settled) return;
        settled = true;
        form.dataset.loading = 'false';
        if (ok) {
          root.dataset.subscribed = 'true';
          remember({ subscribed: true, email });
          showStep(root, 'success');
        } else {
          errEl.textContent = 'Er ging iets mis. Probeer het opnieuw.';
          errEl.hidden = false;
        }
      };

      if (iframe) {
        const onLoad = () => {
          iframe.removeEventListener('load', onLoad);
          let ok = true;
          try {
            const doc = iframe.contentDocument;
            if (doc) {
              const txt = (doc.body && doc.body.innerText) || '';
              if (/cannot be blank|is invalid|too many|captcha/i.test(txt)) ok = false;
            }
          } catch (_) {}
          settle(ok);
        };
        iframe.addEventListener('load', onLoad);
        window.setTimeout(() => settle(true), 6000);
      } else {
        window.setTimeout(() => settle(true), 800);
      }
    });
  }

  function bindCopy(root) {
    const btn = root.querySelector('[data-newsletter-popup-copy]');
    if (!btn) return;
    btn.addEventListener('click', async () => {
      const code = root.dataset.discountCode;
      try {
        await navigator.clipboard.writeText(code);
      } catch (e) {
        const tmp = document.createElement('textarea');
        tmp.value = code;
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        document.body.removeChild(tmp);
      }
      btn.querySelector('[data-newsletter-popup-copy-default]').hidden = true;
      btn.querySelector('[data-newsletter-popup-copy-done]').hidden = false;
      window.setTimeout(() => {
        btn.querySelector('[data-newsletter-popup-copy-default]').hidden = false;
        btn.querySelector('[data-newsletter-popup-copy-done]').hidden = true;
      }, 2400);
    });
  }

  function showStep(root, step) {
    root.querySelectorAll('.newsletter-popup__step').forEach((el) => {
      el.hidden = el.dataset.step !== step;
    });
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
